import { Tag } from '@cian/components';
import * as React from 'react';

import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IIsBasementFloorTagItemProps {
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const IsBasementFloorTagItem = ({ onDeleteClick, withNewTag }: IIsBasementFloorTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Подвал
    </TagComponent>
  );
};
